export const DEFAULT_SUPPORT_ROUTE = '/customers'
export const DEFAULT_AGENCY_ROUTE = '/users'
export const DEFAULT_ADMIN_ROUTE = '/agencyManagement'
